<template>
  <div class="home-box">
    <!-- 顶部菜单 -->
    <div class="menu-bar">
      <button v-for="menu in menus" :key="menu.key" :class="{ active: activeMenu === menu.key }" @click="setActiveMenu(menu, 'click')">
        <h2 class="button_text">{{ menu.name }}</h2>
      </button>
    </div>
	 
	 <PostingModule @operations="operations"></PostingModule>

    <!-- 内容显示 -->
    <div class="content-box">
		<div class="StickyListBox" @click="StickyList()" v-if="StickyListBox">
			<StickyList ref="PostListRef" :Post_List="StickyList_list" :Loading="false" page_name="home" :follow_button="follow_button" @sticky_operations="sticky_operations"></StickyList>
		</div>
		
      <div v-if="activeMenu === 'recommand'" class="recommand-content">
			<PostList ref="PostListRef" :Post_List="recommand_list" :page_obj="page_recommand" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" :follow_button="follow_button" @operations="operations"></PostList>
			<Pagination class="postPagination" v-show="total_num_recommand != 0" :per_page.sync="page_recommand.per_page" :page-sizes="pageSizes" :page.sync="page_recommand.page" :total="total_num_recommand" @pagination="get_page_Data_recommand" ></Pagination>
		</div>
      <div v-if="activeMenu === 'following'" class="following-content">
         <PostList :Post_List="following_list" :page_obj="page_following" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" :follow_button="follow_button" @operations="operations"></PostList>
			<Pagination class="postPagination" v-show="total_num_following != 0" :per_page.sync="page_following.per_page" :page-sizes="pageSizes" :page.sync="page_following.page" :total="total_num_following" @pagination="get_page_Data_following" ></Pagination>
      </div>
      <!-- <div v-if="activeMenu === 'EQSpace'" class="EQSpace-content">
        <PostList :Post_List="EQSpace_list" :parent_type="activeMenu" page_name="page_name" :follow_button="follow_button"></PostList>
      </div> -->
    </div>
  </div>
</template>



<script>
import PostingModule from '../components/public/PostingModule.vue'
import StickyList from '../components/public/StickyList.vue'
import PostList from '../components/public/PostList.vue'
import Pagination from "@/components/Pagination"
import { post_community_posts, post_community_posttops, post_community_userhome, post_community_userinfo } from '@/api/community.js'

export default {
components: { StickyList, PostingModule, PostList, Pagination },
	name: "home",
	data() {
		return {
			menus: [
			  { key: "recommand", name: this.$t('postsArr.Recommand'), type: 1, first: true },
			  { key: "following", name: this.$t('postsArr.Following'), type: 2, first: true  },
			  // { key: "EQSpace", name: "EQ Space", type: 3  },
			],
			activeMenu: "", // 默认选中菜单
			currentMenu: "",
			page_name: "home",
			follow_button: true,
			recommand_list: [],
			EQSpace_list: [],
			following_list: [],
			search: {
				type: 1, //1推荐, 2关注
			},
			page_recommand: {
				page: 1,
				per_page: 10,
			},
			page_following: {
				page: 1,
				per_page: 10,
			},
			Loading: false,
			total_num_recommand: 0,
			total_num_following: 0,
			last_page_recommand: 0,
			last_page_following: 0,
			pageSizes: [10, 20, 30],
			StickyList_list:[],
			StickyListBox: false,
		};
	},	
	
	// 监听
	watch: {
		// "searchText": {
		// 	handler: function (newValue, oldValue) {
		// 		if(this.searchText && this.searchText != ''){
		// 			this.icon_search = false
		// 		}else{
		// 			this.icon_search = true
		// 		}
		// 	},
		// 	deep: true
		// },
	},
	
	// 路由进入可操作数据
	beforeRouteEnter(to, from, next) {
		console.log(to)
		next()
	},
	
	beforeRouteLeave(to, from, next) {
		console.log('路由正在离开帖子列表页面');
	   // 完成相关操作后，调用 next() 允许路由跳转
	   next();
	},
	
	// 路由进入可操作数据
	activated() {
		console.log('路由进来帖子列表页面成功返回');
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		this.post_community_posttops()
		this.$setTags.updateMetaDescription("")
		// this.set_type_list()
	},
	
	// 路由离开时的钩子函数
	deactivated() {
		// 在这里执行路由离开时的操作
		// 可以进行一些清理操作，例如取消请求、清除定时器、释放资源等
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
		
	},
  
	mounted() {
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		this.post_community_posttops()
		this.$setTags.updateMetaDescription("")
		// this.post_community_userinfo()
   },
  
	methods: {
		StickyList(){
			this.$router.push({
				name: "sticky-list",
				// params: params ? params : {}
			})
		},
		
		// 类型切换
		setActiveMenu(menu, click) {
			console.log(this.menus)
			if(this.activeMenu == menu.key && click == 'click'){ return }
			this.currentMenu = menu
			this.activeMenu = menu.key // 更新激活的菜单
			this.search.type = menu.type // 更新激活的菜单
			this.set_type_list(!menu.first ? 'HiddeLoading' : '')
			return menu.first = false
		},
		
		// 根据类型获取数据
		set_type_list(typeName){
			if(this.search.type == 1){
				this.post_community_posts(this.page_recommand, typeName)
			}else{
				this.post_community_posts(this.page_following, typeName)
			}
		},
		
		// 个人信息
		post_community_userinfo(token){
			console.log(token)
			post_community_userinfo()
			   .then((res) => {
					console.log(res)
					if(res.code == 0){
						// this.$store.dispatch('login', [this, 'local', this.dim_url])
						// // response.login_way = 'local'
						this.$store.dispatch('userinfo', [res, this])
						// this.$cookie.set('token', token, { expires: '3D' })
						// this.$cookie.set('user', JSON.stringify(res), { expires: '3D' })
					}
			   })
			   .catch((error) => {
				  console.log(error)
			   })
		},
		
		// 获取分页 recommand
		get_page_Data_recommand(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_recommand.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_recommand.per_page = obj.per_page
			}
			this.post_community_posts(this.page_recommand)
		},
		
		// 获取分页 following
		get_page_Data_following(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_following.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_following.per_page = obj.per_page
			}
			this.post_community_posts(this.page_following)
		},
	 
		//获取帖子列表
		post_community_posts(pageObj, typeName){
			console.log(pageObj)
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
			}
			let obj = {
				type: this.search.type, 
				page: pageObj.page,
				per_page: pageObj.per_page
			}
			console.log(obj)
			post_community_posts(obj)
				.then((res) => {
					console.log(res)
					if(res.code == 0){
						this.data_processing(res)
					}else{
						this.exception_handling(res)
					}
					setTimeout(()=>{
						this.Loading = false
					}, 1500)
					let path = this.$router.currentRoute.path
					this.$setTags.updateCanonical(`${path}?type=${this.search.type}&page=${pageObj.page || 1}`)
					// this.$setTags.updateCanonical(`?type=${this.search.type}&page=${pageObj.page || 1}`)
				})
				.catch((err) => {
					console.log(err)
					this.exception_handling(err)
				})
			},
		
			//数据处理
			data_processing(res){
				let type = this.search.type
				if(type == 1){
					this.recommand_list = res.data.data
					this.total_num_recommand = res.data.total ? res.data.total : 0
					this.last_page_recommand = res.data.last_page ? res.data.last_page : 0
					this.callGrandChildFun()
				}else if(type == 2){
					this.following_list = res.data.data
					this.total_num_following = res.data.total ? res.data.total : 0
					this.last_page_following = res.data.last_page ? res.data.last_page : 0
				}
				// else if(type == 3){
				// 	this.EQSpace_list = res.data
				// }
			},
		
			//异常处理
			exception_handling(err){
				this.Loading = false
				let type = this.search.type
				if(type == 1){
					this.recommand_list = []
					this.total_num_recommand = 0
					this.last_page_recommand = 0
				}else if(type == 2){
					this.following_list = []
					this.total_num_following = 0
					this.last_page_following = 0
				}
				this.$errorMessage(err)
			},
			
			//获取置顶的帖子列表
			post_community_posttops(){
				let obj = {
					page: 1,
					per_page: 1
				}
				console.log(obj)
				post_community_posttops(obj)
					.then((res) => {
						console.log(res)
						if(res.code == 0){
							this.StickyList_list = res.data.data
							if(this.StickyList_list && this.StickyList_list.length > 0){
								this.StickyListBox = true
							}
						}else{
							this.exception_handling(res)
						}
						setTimeout(()=>{
							this.Loading = false
						}, 1500)
					})
					.catch((err) => {
						console.log(err)
						this.exception_handling(err)
					})
				},
		
			//子组件关注操作
			operations(type){
				if(type == 'success'){
					// 操作成功刷新列表数据
					this.set_type_list('HiddeLoading')
					this.if_contain_post('sticky_operations')
				}
			},
			
			//置顶列表的子组件关注操作
			sticky_operations(type){
				console.log(type)
				if(type == 'success'){
					// 操作成功刷新列表数据
					this.post_community_posttops()
					this.if_contain_post('operations')
					// this.set_type_list('HiddeLoading')
				}
			},
			
			//无论是置顶的帖子操作还是默认的帖子操做，判断当前默认帖子是否包含置顶的帖子，有就同步刷新一下
			if_contain_post(type){
				let list = this.activeMenu == 'recommand' ? this.recommand_list : this.following_list
				let StickyItem = this.StickyList_list[0]
				let has = list.some(item => item.post_id == StickyItem.post_id)
				if(has){
					if(type == 'sticky_operations'){
						// 操作成功刷新列表数据
						this.post_community_posttops()
					}else if(type == 'operations'){
						// 操作成功刷新列表数据
						this.set_type_list('HiddeLoading')
					}
				}
			},
			
			// 调用孙子组件的方法
			callGrandChildFun() {
			   // 获取子组件的实例
			   const PostListRef = this.$refs.PostListRef;
			   if (PostListRef && PostListRef.$children && PostListRef.$children.length !== 0) {
			      let children = PostListRef.$children;
			      
			      children.forEach(item => {
			         if (item.set_bg_color) { // 确保方法存在
			            item.set_bg_color('again');
			         } else {
			            console.warn("子组件没有 set_bg_color 方法:", item);
			         }
			      });
			   } else {
			      console.error("未找到 PostListRef 的 ref 或 $children 为空");
			   }
			},

	},
};
</script>

<style lang="less" scoped>
	@import '../components/css/menu.css';
	*{
		box-sizing: border-box;
	}
	.Content-layout{
		background-color: transparent !important;
	}
	.home-box {
	  width: 100%;
	  max-width: 1280px;
	  margin: 0 auto;
	  background-color: transparent;
	}

	.menu-bar {
	  display: flex;
	  justify-content: space-between;
	}

	.menu-bar button {
		border: none;
		font-size: 16px;
		cursor: pointer;
		color: #1E1E1E;
		font-weight: 600;
		width: calc(calc(100% - 10px) / 2);
		border-radius: 8px;
		background-color: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0px 10px;
	}
	.button_text{
		padding: 10px 0px;
		height: 100%;
		flex:  0 0 auto;
		font-size: 16px;
		border-bottom: 2px solid #ffffff;
	}

	.menu-bar button.active .button_text {
	  border-bottom: 2px solid #000000;
	}

	.content-box {
	  margin-top: 10px;
	}

	.recommand-content,
	.EQSpace-content,
	.following-content {
	  background-color: #f9f9f9;
	  border-radius: 8px;
	}
	.StickyListBox{
		width: 100%;
		cursor: pointer;
		// background-color: #fff9f9;
		// background-color: #fffefe;
		background: linear-gradient(to bottom, #fff9f9, #fffefe);
		border-radius: 8px;
		// padding: 10px;
		margin-bottom: 10px;
		// overflow: hidden;
	}
	
	@media screen and (min-width: 1025px) {
		.StickyListBox{
			// height: 300px;
		}
	}
	@media screen and (max-width: 1024px) {
		.StickyListBox{
			// height: 200px;
		}
	}
</style>

